export enum DialogName {
  MembershipInvite = 'MEMBERSHIP_INVITIATION_DIALOG',
}

export default DialogName;
